export type WebMcpTool = {
  name: string;
  description: string;
  inputSchema: {
    type: "object";
    properties: Record<string, unknown>;
    required?: string[];
  };
  annotations?: {
    readOnlyHint?: boolean;
    consequentialHint?: boolean;
  };
  execute: (input: Record<string, unknown>, client?: { signal?: AbortSignal }) => unknown;
};

type ModelContext = {
  registerTool: (tool: WebMcpTool, options?: { signal?: AbortSignal }) => Promise<unknown> | unknown;
};

/** WebMCP is only present in browsers that expose the agent tool API. */
export function getModelContext(): ModelContext | null {
  if (typeof document === "undefined") return null;
  const doc = document as Document & { modelContext?: ModelContext };
  const nav = navigator as Navigator & { modelContext?: ModelContext };
  const ctx = doc.modelContext ?? nav.modelContext;
  if (!ctx || typeof ctx.registerTool !== "function") return null;
  return ctx;
}
